import React, {useEffect, useState} from "react";
import { Button, Card, CardContent, Typography, CircularProgress } from "@mui/material";
import { Loader } from "@googlemaps/js-api-loader";
import {Locate} from "lucide-react";
import {useTranslation} from "react-i18next";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";

const LocateMeButton = (props) => {
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState({});
    const { t } = useTranslation();
    const canLocate = props.skipAuth || props.isAuth;

    useEffect(() => {
        if (location?.coordinates) {
            props.setLocation(location);
        }
    }, [location]);

    const handleLocateMe = async () => {
        if (!canLocate) {
            return;
        }

        setLoading(true);

        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser.");
            setLoading(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;

                try {
                    const loader = new Loader({
                        apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                        libraries: ["places"],
                    });

                    const google = await loader.load();
                    const geocoder = new google.maps.Geocoder();

                    geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
                        if (status === "OK" && results[0]) {
                            const addressComponents = results[0].address_components;
                            const formattedAddress = results[0].formatted_address;
                            const country = getComponent(addressComponents, "country");
                            const province = getComponent(addressComponents, "administrative_area_level_1");

                            setLocation({
                                address: formattedAddress,
                                country,
                                province,
                                coordinates: { lat: latitude, lng: longitude },
                            });
                        } else {
                            alert("Unable to retrieve address.");
                        }
                        setLoading(false);
                    });
                } catch (error) {
                    console.error("Error loading Google Maps API:", error);
                    setLoading(false);
                }
            },
            (error) => {
                alert(`Geolocation error: ${error.message}`);
                setLoading(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 15000,
                maximumAge: 0,
            }
        );
    };

    const getComponent = (components, type) => {
        const component = components.find((c) => c.types.includes(type));
        return component ? component.long_name : "N/A";
    };

    return (
        <Button
            onClick={handleLocateMe}
            disabled={loading}
            variant="contained"
            color="primary"
            size="small"
            startIcon={loading ? <CircularProgress size={14}/> : <Locate className="lucide-small"/>}
            className="field-home-btn"
        >
            {t('locateMe')}
        </Button>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
});
export default withStyles(Styles)(connect(mstp)(LocateMeButton));
